import { Component, OnInit} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, of } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { CMSService } from '../Services/cms.service';
import { CmsContactUsProperties, CmsContactUsFormProperties} from '../Models/CmsContactUsProperties';
import { ContactUsComponentServicesService } from '../Services/contactus.service';
import { CmsFooterContactsProperties, CmsFooterSitemapProperties, CmsFooterSocialProperties } from '../Models/CmsFooterContactsProperties';
import { CmsLoginHeaderProperties, CmsLogoProperties, GetAllCmsLoginProperties } from '../Models/CmsLoginHeaderProperties';
import { CmsLoginMainContentProperties } from '../Models/CmsLoginMainContentProperties';
import { CmsLoginDealsProperties } from '../Models/CmsLoginDealsProperties';
import { EmailItineraryService } from '../Services/emailItinerary.service';
import { EmailItineraryProperties } from '../Models/ERPProperties';
import { faMouse } from '@fortawesome/free-solid-svg-icons';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.css']
})

export class ContactUsComponent implements OnInit {

  constructor(private sanitizer: DomSanitizer,private emailService: EmailItineraryService,private cmsService: CMSService,private activatedRoute: ActivatedRoute,private userService: CMSService, public contactUsService: ContactUsComponentServicesService, private http: HttpClient, private router: Router) { }
  contactUs: CmsContactUsProperties[] = [];
  emailproperties = new EmailItineraryProperties();
  contactUsForm=new  CmsContactUsFormProperties();
  footerContacts: CmsFooterContactsProperties[] = [];
  allData$: GetAllCmsLoginProperties;
  navigation: CmsLoginHeaderProperties[] = [];
  loginLanding: CmsLoginMainContentProperties[] = [];
  deals: CmsLoginDealsProperties[] = [];
  faMouse = faMouse;
  footerSitemap: CmsFooterSitemapProperties[] = [];
  footerSocial: CmsFooterSocialProperties[] = [];
  homeLogo = new CmsLogoProperties();
  logo = '';
  url: SafeResourceUrl;
  dynamicSrc: string = "";
  transform() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      this.dynamicSrc
    );
  }
  ngOnInit() {
    this.getContactData();
    this.getAllData();
    this.getdata();
    this.transform();
  }
  getAllData() {
    try {
      this.cmsService.getAllLoginPageData().subscribe((data) => {
        this.allData$ = data;
        this.homeLogo = this.allData$.logo[0];
        this.logo = this.homeLogo.logo;
        //this.filtersLoaded = Promise.resolve(true);
      });
    } catch (e) { }
  }
  getdata() {

    this.cmsService.getFooterData().subscribe((data) => {


      this.footerContacts = data.footerContacts;


    });
  }
  getContactData() {
    try {
      this.userService.getContactUs().subscribe((data) => {
        this.contactUs = data;
        this.dynamicSrc = data[0].map;
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.dynamicSrc);
      });
    }
    catch (e) {
      //console.log(e);
    }
  }

  public navigateToSection(section: string) {

    window.location.hash = '';

    window.location.hash = section;

  }
  SubmitReq() {
    if (this.contactUsForm.firstName == undefined || this.contactUsForm.firstName == "" || this.contactUsForm.firstName == null) {
      /*   message id here*/
      document.getElementById("namefirstrq").innerHTML = "Required First Name";
      /*      box input id here*/
      document.getElementById("firstinput").classList.add("newRequired-BoxColor");

      setTimeout(function () {
        document.getElementById("namefirstrq").innerHTML = "";
        document.getElementById("firstinput").classList.remove("newRequired-BoxColor");


      }
        , 6000);
    }
    if (this.contactUsForm.lastName == undefined || this.contactUsForm.lastName == "" || this.contactUsForm.lastName == null) {
      /*   message id here*/
      document.getElementById("namelastrq").innerHTML = "Required Last Name";
      /*      box input id here*/
      document.getElementById("lastinput").classList.add("newRequired-BoxColor");

      setTimeout(function () {
        document.getElementById("namelastrq").innerHTML = "";
        document.getElementById("lastinput").classList.remove("newRequired-BoxColor");


      }
        , 6000);
    }
    if (this.contactUsForm.emailUser == undefined || this.contactUsForm.emailUser == "" || this.contactUsForm.emailUser == null) {
      /*   message id here*/
      document.getElementById("nameemailrq").innerHTML = "Required Email";
      /*      box input id here*/
      document.getElementById("emaiinput").classList.add("newRequired-BoxColor");

      setTimeout(function () {
        document.getElementById("nameemailrq").innerHTML = "";
        document.getElementById("emaiinput").classList.remove("newRequired-BoxColor");
      }
        , 6000);
    }
    if (this.contactUsForm.message == undefined || this.contactUsForm.message == "" || this.contactUsForm.message == null) {
      /*   message id here*/
      document.getElementById("namemesagerq").innerHTML = "Required Message";
      /*      box input id here*/
      document.getElementById("messageinput").classList.add("newRequired-BoxColor");

      setTimeout(function () {
        document.getElementById("namemesagerq").innerHTML = "";
        document.getElementById("messageinput").classList.remove("newRequired-BoxColor");
      }
        , 6000);
    }
    if (this.contactUsForm.message == undefined || this.contactUsForm.message == "" || this.contactUsForm.message == null ||
      this.contactUsForm.emailUser == undefined || this.contactUsForm.emailUser == "" || this.contactUsForm.emailUser == null ||
      this.contactUsForm.firstName == undefined || this.contactUsForm.firstName == "" || this.contactUsForm.firstName == null ||
      this.contactUsForm.lastName == undefined || this.contactUsForm.lastName == "" || this.contactUsForm.lastName == null
    ) {
      return;
    }
    this.emailproperties.customerEmail = "info@oktravelsgroup.com";


    this.emailproperties.subject = "Contact this person";
    this.emailproperties.body = "Contact this person";
    this.emailproperties.customerName = this.contactUsForm.firstName + " " + this.contactUsForm.lastName;
    this.emailproperties.body = `
             <div style="flex: 0 0 33.333333%;max-width: 33.333333%;">
               <div style="padding:30px;">
               <div style="display: flex; justify-content: center;">
<h2>
Contact Person Details
</h2>
</div>
<div style="display: flex;flex-wrap: wrap;">
<div style="flex: 0 0 33.333333%;max-width: 33.333333%; display: flex;align-content: center;justify-content: center;">
    <div>


<h3 style="font-weight: bold; ">
    Name:
</h3>
</div>

</div>
<div style="flex: 0 0 66.666667%; max-width: 66.666667%; display: flex;align-content: center;justify-content: center;">
<h3>
    ${this.emailproperties.customerName}
</h3>
</div>
</div>

<div style="display: flex;flex-wrap: wrap;">
<div style="flex: 0 0 33.333333%;max-width: 33.333333%; display: flex;align-content: center;justify-content: center;">
    <div>
<h3 style="font-weight: bold;">
    Email:
</h3>
</div>

</div>
<div style="flex: 0 0 66.666667%;max-width: 66.666667%; display: flex;align-content: center;justify-content: center;">
<h3>
    ${this.contactUsForm.emailUser}
</h3>
</div>
</div>

<div style="display: flex;flex-wrap: wrap;">
<div style="flex: 0 0 33.333333%;max-width: 33.333333%; display: flex;align-content: center;justify-content: center;">
    <div>
<h3 style="font-weight: bold; ">
    Message:
</h3>
</div>

</div>
<div style="flex: 0 0 66.666667%;max-width: 66.666667%; display: flex;align-content: center;justify-content: center;">
<h3>
   ${this.contactUsForm.message}
</h3>
</div>
</div>

    </div>
        </div>
`;
    this.emailService.emailItinerary(this.emailproperties).subscribe((data) => {

      if (data == true) {
        document.getElementById("messageEmail").innerHTML = 'Email Sent';
        setTimeout(() => { document.getElementById("messageEmail").innerHTML = ''; }, 5000);
      }
      else {
        document.getElementById("messageEmail").innerHTML = 'Please Try Again!';
        setTimeout(() => { document.getElementById("messageEmail").innerHTML = ''; }, 5000);
      }
    })
  }
  navitem(i) {

    var nav = document.getElementById(`navitem${i}`) as HTMLAnchorElement;
    nav.href = "";
    nav.href = "/" + this.navigation[i].navItemLink;
    this.router.navigateByUrl(`${nav.href}`);
  }
}
